import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { Circle, MapContainer, Marker, TileLayer } from 'react-leaflet';
import React, { useState } from 'react';
import L from 'leaflet';
import pinIcon from '../../../assets/icons/pin-map.png';
import targetPinIcon from '../../../assets/icons/target-pin-map.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import Bounds from '../Bounds';
import { useTranslation } from 'react-i18next';
import InfoBox from '../../../ui/InfoBox';
import { getDistance } from '../../../helpers';
const userLocationIcon = new L.Icon({
    iconUrl: targetPinIcon,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -20],
});
const targetLocationIcon = new L.Icon({
    iconUrl: pinIcon,
    iconSize: [27, 42],
    iconAnchor: [13, 42],
    popupAnchor: [0, -42],
    shadowUrl: markerShadow,
});
const MapNavigation = ({ targetLocation, radius, userPosition }) => {
    const { i18n, t } = useTranslation();
    const [forceFitBounds, setForceFitBounds] = useState(true);
    const mapRef = React.useRef(null);
    const distance = getDistance(userPosition, targetLocation);
    const handleRecenter = () => {
        setForceFitBounds(true);
        setTimeout(() => setForceFitBounds(false), 500); // Reset the flag after a short delay
    };
    return (_jsxs("div", { className: 'map-container', children: [_jsxs(MapContainer, { center: [userPosition?.lat || 0, userPosition?.lng || 0], zoom: 15, ref: (ref) => {
                    if (ref && !mapRef.current) {
                        mapRef.current = ref;
                        ref.on('dragstart zoomstart', () => {
                            setForceFitBounds(false);
                        });
                    }
                }, style: { height: '100%', width: '100%' }, children: [_jsx(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }), _jsx(Marker, { position: [targetLocation.lat, targetLocation.lng], icon: targetLocationIcon }), _jsx(Circle, { center: [targetLocation.lat, targetLocation.lng], radius: radius, pathOptions: {
                            color: '#1C6DF4',
                            fillColor: '#76B8FF',
                            fillOpacity: 0.68,
                            weight: 2,
                        } }), _jsx(Marker, { position: [userPosition.lat, userPosition.lng], icon: userLocationIcon }), _jsx(Bounds, { userLocation: userPosition, targetLocation: targetLocation, forceFitBounds: forceFitBounds })] }), _jsx("button", { className: 'map-control-button', onClick: handleRecenter, children: t('button.recenter_map') }), _jsx("div", { className: 'distance', children: _jsx(InfoBox, { textContent: i18n.language === 'de'
                        ? `${t('label.left')} ${distance.toFixed(2)} m`
                        : `${distance.toFixed(2)} m ${t('label.left')}`, backgroundColor: '#f39200' }) })] }));
};
export default MapNavigation;
